import React, { useEffect, useState } from "react";
import { Image } from "antd-mobile";
import { isDef } from "@/util/validate";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { isEmpty } from "lodash";
import { pxToRem } from "@/util/common";

interface AvatarProps {
	url?: string; // 头像图片的 URL
	pUrl?: string; // 占位图的 URL
	width: number; // 头像的宽度
	height: number; // 头像的高度
}

const AvatarImage: React.FC<AvatarProps> = ({ url, pUrl, width, height }) => {
	const { userInfo, nativeUser } = useSelector(
		(state: RootState) => state.auth
	);

	const [avatar, setAvatar] = useState(
		require("@/assets/images/icons/Avatar.png")
	);

	useEffect(() => {
		if (!isEmpty(url)) {
			setAvatar(url);
			return;
		}
		if (isDef(nativeUser)) {
			if (isDef(nativeUser.avatar)) {
				setAvatar(nativeUser.avatar);
			}
		}
	}, [userInfo, nativeUser, url]);

	return (
		<Image
			src={avatar}
			width={pxToRem(width)}
			height={pxToRem(height)}
			style={{ borderRadius: "100%" }}
			fallback={
				<Image
					src={pUrl ?? require("@/assets/images/icons/Avatar.png")}
					width={pxToRem(width)}
					height={pxToRem(height)}
				/>
			}
		/>
	);
};

export default AvatarImage;
